import * as THREE from "../../libs/three.js/build/three.module.js";
import { MOUSE } from "../defines.js";
import { EventDispatcher } from "../EventDispatcher.js";

export class KrpanoControls extends EventDispatcher {
  constructor(viewer) {
    super(viewer);

    this.viewer = viewer;
    this.renderer = viewer.renderer;

    this.scene = null;
    this.sceneControls = new THREE.Scene();

    this.moveSpeed = 50;
    this.fovSpeed = 4;
    this.keys = {
      LEFT: [37],
      UP: [38],
      RIGHT: [39],
      DOWN: [40],
    };

    this.fadeFactor = 50;
    this.yawDelta = 0;
    this.pitchDelta = 0;

    this.tweens = [];

    let drag = (e) => {
      if (e.drag.object !== null) {
        return;
      }

      if (e.drag.startHandled === undefined) {
        e.drag.startHandled = true;

        this.dispatchEvent({ type: "start" });
      }

      let moveSpeed = this.viewer.getMoveSpeed();

      let ndrag = {
        x: e.drag.lastDrag.x / this.renderer.domElement.clientWidth,
        y: e.drag.lastDrag.y / this.renderer.domElement.clientHeight,
      };

      if (e.drag.mouse === MOUSE.LEFT) {
        this.moveSpeed = viewer.getMoveSpeed();
        this.yawDelta -= ndrag.x * this.moveSpeed; //minus instead of plus to match krpano
        this.pitchDelta -= ndrag.y * this.moveSpeed;
      } /*else if (e.drag.mouse === Potree.MOUSE.RIGHT) {
				this.translationDelta.x -= ndrag.x * moveSpeed * 100;
				this.translationDelta.z += ndrag.y * moveSpeed * 100;
			}*/
    };

    let drop = (e) => {
      this.dispatchEvent({ type: "end" });
    };

    let scroll = (e) => {
      let fov = viewer.getFOV() - this.fovSpeed * e.delta;
      if (fov < 11.5) fov = 11.5; //min krpano fov;
      if (fov > 120) fov = 120; //max krpano fov;
      viewer.setFOV(fov);
    };

    //dblclick still zoom?

    this.addEventListener("drag", drag);
    this.addEventListener("drop", drop);
    this.addEventListener("mousewheel", scroll);
    //this.addEventListener('dblclick', dblclick);
  }

  static str() {
    return "krpano";
  }

  setScene(scene) {
    this.scene = scene;
  }

  stop() {
    this.yawDelta = 0;
    this.pitchDelta = 0;
  }

  update(delta) {
    let view = this.scene.view;

    {
      // cancel move animations on user input
      let changes = [this.yawDelta, this.pitchDelta];
      let changeHappens = changes.some((e) => Math.abs(e) > 0.001);
      if (changeHappens && this.tweens.length > 0) {
        this.tweens.forEach((e) => e.stop());
        this.tweens = [];
      }
    }

    {
      // rotate while input is given
      let ih = this.viewer.inputHandler;

      let lookLeft = this.keys.LEFT.some((e) => ih.pressedKeys[e]);
      let lookRight = this.keys.RIGHT.some((e) => ih.pressedKeys[e]);
      let lookUp = this.keys.UP.some((e) => ih.pressedKeys[e]);
      let lookDown = this.keys.DOWN.some((e) => ih.pressedKeys[e]);

      if (lookLeft) {
        if (!lookRight) view.yaw += this.moveSpeed / 100;
      } else if (lookRight) view.yaw -= this.moveSpeed / 100;

      if (lookUp) {
        if (!lookDown) view.pitch += this.moveSpeed / 100;
      } else if (lookDown) view.pitch -= this.moveSpeed / 100;
    }

    {
      // apply rotation
      let yaw = view.yaw;
      let pitch = view.pitch;

      yaw -= this.yawDelta * delta;
      pitch -= this.pitchDelta * delta;

      view.yaw = yaw;
      view.pitch = pitch;
    }

    {
      // set view target (???)
      view.radius = 3;
    }

    {
      // decelerate over time
      let attenuation = Math.max(0, 1 - this.fadeFactor * delta);
      this.yawDelta *= attenuation;
      this.pitchDelta *= attenuation;
    }
  }
}
